interface Props {
  errorMessage: string
  dataTestId?: string
}

function ErrorHintForm({ errorMessage, dataTestId }: Props) {
  return (
    <p className="mb-1 mt-0 text-[#FF4D4D] text-xs font-normal" data-testid={dataTestId}>
      {errorMessage}
    </p>
  )
}

export default ErrorHintForm
